import { IconSettings } from '@ryusei/code';


/**
 * Icon settings as [ path, stroke?, linecap? ].
 *
 * @since 0.1.0
 */
export const ICONS: Record<string, IconSettings> = {
  arrowUp: [
    'm18.6 10.3c-6.59-6.85-6.59-6.85-6.59-6.85m-6.59 6.85 6.59-6.85m0 17v-17',
    3,
  ],
  arrowDown: [
    'm5.41 13.7 6.59 6.85m6.59-6.85c-6.59 6.85-6.59 6.85-6.59 6.85m0-17v17',
    3,
  ],
  close: [
    'm19 18-14-13m0 13 14-13',
    3,
  ],
};
